import { createServerFn } from "@tanstack/react-start";

/** Public: gives the browser a playable link for one social post. */
export const getPlayablePost = createServerFn({ method: "POST" })
  .inputValidator((input: { postId: string }) => {
    if (!input?.postId) throw new Error("Missing post");
    return { postId: input.postId };
  })
  .handler(async ({ data }) => {
    const { resolvePlayableMedia } = await import("./socialMedia.server");
    try {
      const media = await resolvePlayableMedia(data.postId);
      if (!media) return { mediaUrl: null as string | null, error: "Post not found" };
      return { mediaUrl: media.mediaUrl, error: null as string | null };
    } catch (e) {
      console.error("getPlayablePost failed:", (e as Error).message);
      return { mediaUrl: null as string | null, error: "Could not load this video" };
    }
  });

/** Public: resolves several posts in one request so the feed starts faster. */
export const getPlayablePosts = createServerFn({ method: "POST" })
  .inputValidator((input: { postIds: string[] }) => {
    const postIds = Array.isArray(input?.postIds) ? input.postIds.filter(Boolean).slice(0, 12) : [];
    if (postIds.length === 0) throw new Error("Missing posts");
    return { postIds };
  })
  .handler(async ({ data }) => {
    const { resolvePlayableMedia } = await import("./socialMedia.server");
    const results = await Promise.all(
      data.postIds.map(async (postId) => {
        try {
          const media = await resolvePlayableMedia(postId);
          return { postId, mediaUrl: media?.mediaUrl ?? null };
        } catch (e) {
          console.error("getPlayablePosts failed:", (e as Error).message);
          return { postId, mediaUrl: null as string | null };
        }
      }),
    );
    return { results };
  });
